import type { VehicleCard } from "../../types/vtc";
import SectionHeading from "../ui/SectionHeading";
import VehicleCardItem from "./VehicleCardItem";
import { useT } from "../../i18n";

interface PopularVehiclesProps {
  vehicles: VehicleCard[];
  loading?: boolean;
  /** The API couldn't be reached. */
  error?: boolean;
}

function CardSkeleton() {
  return (
    <div className="flex flex-col overflow-hidden rounded-lg border border-line-strong">
      <div className="aspect-16/10 animate-pulse bg-surface" />
      <div className="flex flex-col gap-2 p-4">
        <div className="h-5 w-2/3 animate-pulse rounded bg-surface" />
        <div className="h-4 w-1/2 animate-pulse rounded bg-surface" />
        <div className="h-9 w-full animate-pulse rounded bg-surface" />
      </div>
    </div>
  );
}

export default function PopularVehicles({
  vehicles,
  loading = false,
  error = false,
}: PopularVehiclesProps) {
  const t = useT();
  return (
    <section className="mx-auto max-w-7xl px-4 pb-6 pt-16 sm:px-6 sm:pt-18">
      <SectionHeading
        title={t.home.popularTitle}
        action={
          <a
            href="/vehicles"
            className="text-sm font-medium text-ink no-underline hover:underline"
          >
            {t.home.viewAllVehicles}
          </a>
        }
      />

      {!loading && vehicles.length === 0 && (
        <p className="m-0 rounded-lg bg-surface px-5 py-8 text-center text-sm text-muted">
          {error ? t.home.popularError : t.home.popularEmpty}
        </p>
      )}

      {/* Phones: compact cards, two per row (all four visible, no scrolling) */}
      <div className="grid grid-cols-2 gap-2.5 sm:gap-5 lg:grid-cols-3 xl:grid-cols-4">
        {loading
          ? Array.from({ length: 4 }).map((_, i) => <CardSkeleton key={i} />)
          : vehicles.map((vehicle) => (
              <VehicleCardItem key={vehicle.id} vehicle={vehicle} compact />
            ))}
      </div>
    </section>
  );
}
